import React from 'react';
import bannerImg from '../imgs/banner.jpg'

const PageBanner = ({ title = '', subtitle = '' }) => {
  const bannerStyle = {
        backgroundImage: `linear-gradient(rgba(0,0,0,0.01)), url(${bannerImg})`,
       backgroundSize: 'cover',
       backgroundPosition: 'center',
       backgroundRepeat: 'no-repeat',
       minHeight: '240px',
       display: 'flex',
       alignItems: 'center',
       justifyContent: 'center',
       textAlign: 'center'
  };

  return (
    <section style={bannerStyle}>
      <div className="container" style={{ padding: '0 0 12px 0', textAlign: 'center' }}>
        {title ? (
          <span
            style={{
              display: 'inline-block',
              background: 'rgba(0,0,0,0.45)',
              padding: '12px 28px',
              borderRadius: '14px',
              backdropFilter: 'blur(2px)',
              WebkitBackdropFilter: 'blur(2px)',
              boxShadow: '0 6px 18px rgba(0,0,0,0.25)'
            }}
          >
            <h1 style={{ margin: 0, color: '#ffbf00', fontWeight: 800, letterSpacing: '.5px' }}>{title}</h1>
          </span>
        ) : null}
        {subtitle ? (
          <div style={{ marginTop: 14 }}>
            <span
              style={{
                display: 'inline-block',
                background: 'rgba(0,0,0,0.35)',
                padding: '6px 18px 8px',
                borderRadius: '10px',
                backdropFilter: 'blur(2px)',
                WebkitBackdropFilter: 'blur(2px)'
              }}
            >
              <p style={{ margin: 0, color: '#ffbf00', opacity: 0.95, fontWeight: 600 }}>{subtitle}</p>
            </span>
          </div>
        ) : null}
      </div>
    </section>
  );
};

export default PageBanner;